import { PickListDesignTokens } from '../../../../types/picklist';

export default {
    root: {
        gap: '1.125rem'
    },
    controls: {
        gap: '0.5rem'
    }
} as PickListDesignTokens;
